<div
    class="cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-cg-0dot5 cmps-cdk-px-0dot5 cmps-cdk-h-45px"
>
    <div
        class="cmps-cdk-w-10px cmps-cdk-h-10px cmps-cdk-bg-color-blue-100 cmps-cdk-border-radius-50pct"
    ></div>
    <div
        class="cmps-cdk-font-size-14p cmps-cdk-font-bold cmps-cdk-text-uppercase"
    >
        <div>{{ group?.label }}</div>
    </div>
    <div
        class="cmps-cdk-border-width-1p cmps-cdk-border-solid cmps-cdk-border-color-unknown-107 cmps-cdk-border-radius-12px cmps-cdk-bg-color-white cmps-cdk-color-unknown-122 cmps-cdk-font-bold cmps-cdk-px-0dot5 cmps-cdk-white-space-nowrap"
    >
        <span
            *ngIf="
                (group?.areas?.length ?? 0) < 1 ||
                (group?.areas?.length ?? 0) > 1
            "
            >{{ group?.areas?.length ?? 0 }} Foci</span
        >
        <span *ngIf="(group?.areas?.length ?? 0) === 1"
            >{{ group?.areas?.length ?? 0 }} Focus</span
        >
    </div>
    <div class="cmps-cdk-flex-grow-1"></div>
    <div class="cmps-cdk-font-size-18p cmps-cdk-font-bold">
        {{ group?.scorePercent ?? 0 | cmpsPercent: '1.0-0' }}
    </div>
</div>
